import React from "react";

import ClickableText from "../../../../components/common/clickable_text";
import { Text } from "../../../../components/common/typography";
import { AppRoutes } from "../../../../common/routes/app_routes";

const Footer: React.FC = () => {
  return (
    <footer className="w-full mt-auto flex-shrink-0 bg-bgDefault text-textPrimary text-center py-4 px-6 flex flex-col items-center justify-center gap-1 print:hidden">
      <div className="text-sm flex flex-wrap gap-2 justify-center px-6">
        <ClickableText
          text="Terms & Conditions"
          href={AppRoutes.TERMS_AND_CONDITIONS}
          className="text-sm hover:underline"
        />
        <span>·</span>
        <ClickableText
          text="Privacy Policy"
          href={AppRoutes.PRIVACY_POLICY}
          className="text-sm hover:underline"
        />
        <span>·</span>
        <ClickableText
          text="Return Policy"
          href={AppRoutes.RETURN_POLICY}
          className="text-sm hover:underline"
        />
      </div>
      {/* Build version — part of the page flow so it never overlaps content. */}
      <Text variant="bodyXs" tone="muted">
        v{APP_VERSION}
      </Text>
    </footer>
  );
};

export default Footer;
